import { useApp } from '../AppContext';

export default function Toast() {
  const { toast } = useApp();
  return (
    <div className={`toast${toast.visible ? ' show' : ''}`}>
      {toast.msg}
    </div>
  );
}
